export enum FontWeight {
  Light = 'OpenSans-Light',
  Regular = 'OpenSans',
  Semibold = 'OpenSans-Semibold',
  Bold = 'OpenSans-Bold'
}
